/* eslint-disable @typescript-eslint/naming-convention */
import { FeatureFlag, FeatureFlagParam } from '@ps/web-core-enums';
import { DebugKey, createDebug, getWindow } from '@ps/web-core-utils';
import type { paths } from '@ps/web-shared-api-types/FeatureFlags';
import { isArray, isObject, reduce } from 'lodash';

import { createClient } from '../../api/createClient';
import type { EffectParams, FeatureFlagRequestBody } from '../../types';

import type { Feature } from './feature';

const requestBody = (body: FeatureFlag[] | FeatureFlagRequestBody | undefined) => {
  switch (true) {
    case isArray(body):
      return { features: body };
    case isObject(body):
      return { features: body.features || Object.values(FeatureFlag), query: body.query };
    default:
      return { features: Object.values(FeatureFlag) };
  }
};
const effects = {
  async check(
    payload: FeatureFlag[] | FeatureFlagRequestBody | undefined,
    { dispatch, request, rootState, select, store }: EffectParams
  ) {
    const isEmbedded = select.device.isEmbedded(rootState);
    const { ffFetchMode } = select.config.get(rootState);
    const isAuthenticated = select.session.isAuthenticated(rootState);
    const { idpToken } = select.session.get(rootState);
    const isAliasDomain = select.cms.isAliasDomain(rootState);
    const body = requestBody(payload);

    if (
      process.env.NODE_ENV === 'test' ||
      (isEmbedded && !getWindow()?.starsweb?.auth.idpToken) ||
      (isAuthenticated && !idpToken) ||
      ffFetchMode === 'ws' ||
      isAliasDomain
    ) {
      const { body } = await request<Feature>({
        service: 'features.check',
        body: requestBody(payload)
      });
      dispatch.feature.update(body);
    } else {
      const balance = select.account.getTotalBalanceInUsd(rootState);

      const vppPoints = body.query?.[FeatureFlagParam.MinLtVpp];
      const client = createClient<paths>(store);
      await client
        .POST('/wp/features', {
          params: { header: {} },
          body: {
            flags: requestBody(payload).features,
            context: { user: { balance, vppPoints } }
          }
        })
        .then((response) => {
          const { data, error } = response;
          if (data) {
            const flags: Feature = reduce(
              data,
              (res, { flag, value }) => (flag ? Object.assign(res, { [flag]: value }) : res),
              {}
            );
            dispatch.feature.update(flags);
          } else {
            throw new Error(JSON.stringify(error));
          }
        })
        .catch((error) => {
          createDebug(DebugKey.Error)(`Kong feature flag call failed: ${error}`);
          throw error;
        });
    }
  }
};

export default effects;
